import React, { ReactElement, Children } from 'react';
import useSetCurrentCameras from "../../hooks/useSetCurrentCameras";
import useRunPollEvents from "../../hooks/useRunPollEvents";
import useSetStoredData from "../../hooks/useSetStoredData";

interface Props {
    children: ReactElement | ReactElement[]
}

const PreloadComponent = ({ children } : Props) => {
    useSetCurrentCameras();
    useSetStoredData();
    useRunPollEvents();
    
    return (
        <>
            { Children.map(children, child => React.cloneElement(child) ) }
        </>
    )
};

export default PreloadComponent